import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { ContratoStatus } from 'src/app/core/models/onboarding/ContratoStatus';
import { OnboardingService } from 'src/app/core/services/onboarding';

@Component({
  selector: 'app-onboarding-contrato',
  templateUrl: './onboarding-contrato.component.html',
  styleUrls: ['./onboarding-contrato.component.scss'],
})
export class OnboardingContratoComponent implements OnInit {
  @Output() next = new EventEmitter();

  onboardingService = inject(OnboardingService);

  contratoStatus?: ContratoStatus;

  ngOnInit(): void {
    this.loadOnboardingStatus();
  }

  onNextClick(): void {
    this.next.emit();
  }

  private loadOnboardingStatus(): void {
    this.onboardingService.getContratoStatus().subscribe((contratoStatus) => {
      this.contratoStatus = contratoStatus;
    });
  }
}
